// Small preview of a legend material's hatch pattern, tinted with the same
// color used elsewhere for that material (e.g. the editor's Layer controls
// dot), so users can tell which pattern/color a wall type maps to without
// opening the editor.
//
// When `imageB64` is available (the real crop of the legend's swatch box,
// extracted from the source PDF), it is shown directly — that's the
// authentic pattern, not an approximation. The synthetic SVG pattern below
// is only a fallback for entries with no resolved swatch image (e.g. older
// cached job results, or a swatch rect that couldn't be located).
export default function HatchSwatch({ color = "#999999", hatchFeatures, imageB64, size = 22 }) {
  if (imageB64) {
    return (
      <img
        src={`data:image/png;base64,${imageB64}`}
        alt=""
        aria-hidden="true"
        className="hatch-swatch hatch-swatch--image"
        width={size}
        height={size}
        style={{ borderColor: color }}
      />
    );
  }

  const noData = !hatchFeatures;
  const diagEnergy = hatchFeatures?.diag_energy ?? 0;
  const diagBalance = hatchFeatures?.diag_balance ?? 0;
  const greyFillShare = hatchFeatures?.grey_fill_share ?? 0;
  const dashed = (hatchFeatures?.dash_ratio ?? 0) > 0.3;

  const isSolid = noData || (greyFillShare >= 0.5 && diagEnergy < 0.3);
  const isCross = !isSolid && diagBalance >= 0.6 && diagEnergy >= 0.1;
  const isHatch = !isSolid && !isCross && diagEnergy >= 0.1;

  const patternKind = isSolid ? "solid" : isCross ? "cross" : isHatch ? "diag" : "flat";
  const patternId = `hatch-swatch-${patternKind}-${color.replace("#", "")}`;
  const dashArray = dashed ? "3 2" : undefined;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      className="hatch-swatch"
      aria-hidden="true"
    >
      <defs>
        <pattern
          id={patternId}
          width="6"
          height="6"
          patternUnits="userSpaceOnUse"
          patternTransform="rotate(45)"
        >
          <rect width="6" height="6" style={{ fill: "var(--ds-domain-paper)" }} />
          {(isHatch || isCross) && (
            <line x1="0" y1="3" x2="6" y2="3" stroke={color} strokeWidth="1.4" strokeDasharray={dashArray} />
          )}
          {isCross && (
            <line x1="3" y1="0" x2="3" y2="6" stroke={color} strokeWidth="1.4" strokeDasharray={dashArray} />
          )}
        </pattern>
      </defs>
      <rect
        x="0.5"
        y="0.5"
        width="19"
        height="19"
        rx="3"
        fill={isSolid ? color : `url(#${patternId})`}
        fillOpacity={isSolid ? 0.85 : 1}
        stroke={color}
        strokeWidth="1"
      />
    </svg>
  );
}
